<template>
  <div id="app">
    <v-app id="inspire">
      <page-header />
      <v-content>
        <v-container fluid fill-height>
          <router-view/>
        </v-container>
      </v-content>
      <page-footer />
    </v-app>
  </div>
</template>

<script>
import PageHeader from '@/components/navigation/NavBar'
import PageFooter from '@/components/navigation/BottomNav'

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter
  }
}
</script>

<style>
html {
  -webkit-overflow-scrolling: touch;
}

.vgt-fixed-header {
  z-index: 1 !important;
}

.vgt-table th.line-numbers, .vgt-table th.vgt-checkbox-col {
  width: 60px !important;
}

.add-button-bottom {
  bottom: 64px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue